import { Column } from 'react-data-grid'
import { User } from 'domain/User'
import Button from 'react-bootstrap/Button'
import { ColumnsConfigProps } from './types'

export const columnsConfig = (props: ColumnsConfigProps): Column<User>[] =>
    [
        { key: 'order', name: '#', width: 45 },
        { key: 'id', name: 'User ID', width: 45 },
        { key: 'login', name: 'Login' },
        { key: 'level', name: 'Level' },
        {
            key: '',
            name: '',
            width: 135,
            formatter: data => {
                return (
                    <Button
                        size="sm"
                        variant="outline-success"
                        onClick={() => props.resetPassword(data.row.login)}>
                        Reset password
                    </Button>
                )
            },
        },
    ] as Column<User>[]
